import { SIGNOUT_USER_SUCCESS } from '../User/UserTypes';
import * as TYPES from './AllergiesTypes';

const initialState = {
  list: [],
};

export default function AllergiesReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  if (type === TYPES.ALLERGY_LIST_SUCCESS) {
    return {
      ...state,
      list: payload,
    };
  } else if (type === SIGNOUT_USER_SUCCESS) {
    return initialState;
  }
  return state;
}
